import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h2>O aplikaciji</h2>
        <p>
          Wetland Guardian predstavlja bazu podataka o stanju vlažnih staništa i njihovom geografskom položaju koje su prikupili građani naučnici.
        </p>
        <p>
          Razumevanje stanja i rasprostranjenosti vlažnih staništa ključno je za njihovu zaštitu i ispunjavanje međunarodnih obaveza poput Ramsarske konvencije o vlažnim staništima, Ciljeva održivog razvoja Ujedinjenih Nacija i Pariskog sporazuma o klimatskim promenama. Međutim, podaci o stanju vlažnih staništa i ugrožavajućim faktorima su veoma ograničeni. Vaši podaci pomažu da se ovaj jaz premosti!
        </p>
        <p>
          <strong>Zašto je važno?</strong> Vlažna staništa su među najvrednijim ekosistemima – podržavaju biodiverzitet, regulišu vodne tokove, prečišćavaju vodu, skladište ugljenik, ublažavaju poplave i pružaju resurse za ljude i prirodu.
        </p>
        <p>
          <strong>Kako možete pomoći?</strong> Unošenjem svojih zapažanja doprinosite očuvanju vlažnih staništa.
        </p>
        <p>Podaci prikupljeni ovom aplikacijom mogu:</p>
        <ul>
          <li>biti informacija za adekvatne institucije koje se bave zaštitom i obnovom prirode gde je najpre potrebno preduzeti hitne mere</li>
          <li>biti korišćene od naučnika (eksperata, ali i građana) za analizu i oblikovanje budućih akcija zaštite i obnove vlažnih staništa</li>
        </ul>
        <p>
          Za više informacija o zaštiti vlažnih staništa posetite: <a href="http://serbiawetlands.rs" target="_blank" rel="noopener noreferrer">serbiawetlands.rs</a>.
        </p>

        <h2>Uslovi korišćenja</h2>
        <p>
          Korišćenjem aplikacije Serbia Wetlands korisnik/ca prihvata da sve informacije i fotografije koje unosi moraju biti relevantne za opisivanje močvarnih područja u Srbiji. Korisnik/ca je odgovoran/a za tačnost i prikladnost unetih podataka.
        </p>
        <p>
          Sve unose (tekstualni podaci i fotografije) će pregledati administrator sistema pre javnog objavljivanja. Administrator ima pravo da odbije, izmeni ili ukloni sadržaj koji nije u skladu sa namenom aplikacije ili pravilima korišćenja.
        </p>
        <p>
          Korišćenjem aplikacije, korisnik/ca se obavezuje da neće unositi neprimerene, uvredljive ili lažne podatke.
        </p>

        <h2>Svrha obrade i politika zaštite podataka</h2>
        <p>
          Aplikacija Serbia Wetlands čuva samo osnovne podatke o korisnicima — ime i imejl adresu — koji se koriste isključivo za verifikaciju korisničkog naloga.
        </p>
        <p>
          Fotografije koje korisnik otpremi kao deo opisa lokacije treba da budu u skladu sa svrhom aplikacije (prikaz stanja i karakteristika močvarnog područja).
        </p>
        <p>
          Za upravljanje podacima je odgovoran Institut za biološka istraživanja „Siniša Stanković", Institut od nacionalnog značaja za Republiku Srbiju, Univerziteta u Beogradu.
        </p>
        <p>Svrha obrade podataka je:</p>
        <ol>
          <li>Čuvanje i prikaz korisničkih opažanja u aplikaciji i na interaktivnim mapama.</li>
          <li>Naučna analiza korišćenjem anonimizovanih podataka.</li>
          <li>Informisanje donosilaca odluka i praksi u vezi sa zaštitom i obnovom vlažnih staništa.</li>
        </ol>
        <p>
          Ukoliko korisnik/ca želi da obriše svoj nalog ili bilo koji od svojih unosa, može podneti zahtev za brisanje putem imejla na adresu: <a href="mailto:wetlandguardian@ibiss.bg.ac.rs">wetlandguardian@ibiss.bg.ac.rs</a>
        </p>

        <h2>O projektu</h2>
        <p>
          Aplikacija je razvijena u okviru projekta „Zaštita i ulaganje u biodiverzitet i vode za jačanje otpornosti na klimatske promene", koji sprovodi UNDP uz podršku Švedske, odnosno Švedske agencije za međunarodni razvoj i saradnju (Sida), u okviru inicijative „EU za Zelenu agendu u Srbiji". Ovu inicijativu, uz tehničku i finansijsku podršku Evropske unije i u partnerstvu sa Ministarstvom zaštite životne sredine, sprovodi UNDP u saradnji sa Švedskom i Evropskom investicionom bankom (EIB), uz dodatna finansijska sredstva koja su obezbedile vlade Švedske, Švajcarske i Srbije.
        </p>
      </div>
    </div>
  );
};

export default About;
